export default __webpack_public_path__ + "static/media/credhome-sprite.822b17f0.png";